export default [
    {
        path: "/license",
        redirect: "/license/active",
        name: "license",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "active",
                name: "Thông tin giấy phép bản quyền",
                component: () => import("@/views/pages/License"),
                meta: {
                    requiresAuth: false,
                    title: "Thông tin giấy phép bản quyền"
                },
            },
        ],
    }
]